module.exports = __webpack_public_path__ + "img/04.f3e51908.svg";